module.exports = __webpack_public_path__ + "static/media/18ECA4.eb0a9ecf.jpg";